import { Component } from "preact";
import ActivitySelect from "../../routes/Location/ActivitySelect";
import BoxOpeningPage from "../../routes/OpenBox/BoxOpeningPage";
import OpenBoxPinPage from "../../routes/OpenBox/OpenBoxPinPage";
import OpenBoxPage from "../../routes/OpenBox/OpenBoxPage";
import RentWizard from "../../routes/RentWizard/RentWizard";
import { E_Route } from "../../models/constants/Enum_Routes";
import { E_RentWizard_Section } from "../../models/constants/Enums_RentWizard";
import Router from "preact-router";
import Route from "../shared/Route";
import BoxRentOvertimePage from "../../routes/OpenBox/BoxRentOvertimePage";
import DeliveryWizard from "../../routes/DeliveryWizard/DeliveryWizard";
import { E_DeliveryWizard_Section } from "../../models/constants/Enums_DeliveryWizard";

class RouterSwitch extends Component {
	render() {
		return (
			<Router>
				<OpenBoxPage path={E_Route.OPEN_BOX}/>
				<Route path={E_Route.OPEN_BOX_PIN()}>
					{props => {
						return <OpenBoxPinPage boxAction={props.action}/>;
					}}
				</Route>
				<Route path={E_Route.BOX_OPENING()}>
					{props => <BoxOpeningPage boxAction={props.action} timeout={parseInt(props.timeout)} physicalReference={props.physicalReference}/>}
				</Route>
				<Route path={E_Route.RENT_WIZARD()}>
					{props => <RentWizard section={props.section || E_RentWizard_Section.TARIFF_SELECTION}/>}
				</Route>
				<Route path={E_Route.BOX_RENT_OVERTIME()}>
					{props => <BoxRentOvertimePage boxAction={props.action} physicalReference={props.physicalReference} sessionID={parseInt(props.sessionID)} additionalPaymentAmount={parseInt(props.additionalPaymentAmount)}/>}
				</Route>
				<Route path={E_Route.DELIVERY_WIZARD()}>
					{props => <DeliveryWizard section={props.section || E_DeliveryWizard_Section.PARTNER_SELECT}/>}
				</Route>

				<ActivitySelect default/>
			</Router>
		);
	}
}

export default RouterSwitch;
